import { createFileRoute, Navigate } from "@tanstack/react-router";

export const Route = createFileRoute("/app/")({
  component: AppHome,
});

function AppHome() {
  // Redirect to clubs discovery page — the main entry point for the app
  return <Navigate to="/app/clubs" />;
}
